import { radio_selected, radio_unselected } from '@assets/icons';
import { Radio } from '@mui/material';
import { Text } from '..';
import { CSSProperties } from 'react';

interface IRadioItemProps {
  label: string;
  boxstyle?: CSSProperties;
  value: string;
  image?: string;
  imageSize?: number;
  onChange: (value: any) => void;
}

export const RadioItem = (props: IRadioItemProps) => {
  const { label, boxstyle, value, image, imageSize = 100, onChange } = props;

  return (
    <>
      {image ? (
        <div
          onClick={() => {
            onChange(value);
          }}
          style={boxstyle ? boxstyle : { cursor: 'pointer', width: 100 }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              marginBottom: '6px'
            }}
          >
            <img src={image} alt="" style={{ width: imageSize, height: imageSize }} />
          </div>
          <div style={{ display: 'flex' }}>
            <Radio
              value={value}
              checkedIcon={<img src={radio_selected} alt="" style={{ width: 20, height: 20 }} />}
              icon={<img src={radio_unselected} alt="" style={{ width: 20, height: 20 }} />}
            />
            <Text variant="body1">{label}</Text>
          </div>
        </div>
      ) : (
        <div
          onClick={() => {
            onChange(value);
          }}
          style={boxstyle ? boxstyle : { cursor: 'pointer', width: 100 }}
        >
          <div style={{ display: 'flex' }}>
            <Radio
              value={value}
              checkedIcon={<img src={radio_selected} alt="" style={{ width: 20, height: 20 }} />}
              icon={<img src={radio_unselected} alt="" style={{ width: 20, height: 20 }} />}
            />
            <Text variant="body1">{label}</Text>
          </div>
        </div>
      )}
    </>
  );
};
